import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Upload = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4bd__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb4bd__a)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M23.996 4h-.004c-.608 0-1.151.27-1.518.698l-8.888 8.888a2 2 0 0 0 2.828 2.828l5.578-5.577V32a2 2 0 0 0 4 0V10.82l5.594 5.594a2 2 0 0 0 2.828-2.828l-9-9A2 2 0 0 0 24 4h-.004ZM44 42V24a2 2 0 0 0-4 0v16H8V24.008a2 2 0 0 0-4 0V42a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
